import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Syndicate } from './syndicate';

export class Cast extends Node {
    public static _type: string = 'Cast';
    public data: any;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.data = source.data;
        }
    }

    public copy(source?: any) {
        super.copy(source);

        if (source) {
            this.data = source.data;
        }
    }

    public override fit(branch: Branch): boolean {
        return branch instanceof Syndicate;
    }
}
